import { executePost } from "../../../Utils/ServiceMethods";
import { toast } from "react-toastify";
import { SessionTimeout } from "../../../Utils/ErrorMessages";
import { removeUserCredentials } from "../../../Utils/LocalStorage";

export const getCouponData = async (couponId,cb) => {
  try {
    const couponData = await executePost(
      "/get-marketplace-coupon",
      {
        coupon_id: Number(couponId),
      },
    );
    return couponData.data;
  } catch (error) {
    if (error.response?.data?.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();

      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });

      removeUserCredentials();
      if (cb) cb();
    }
  }
};
